const admissionManagementRoutes = (prop) => [
    {
        path: 'prepare-circular',
        name: prop + '.prepare_circular',
        meta: { auth: true },
        component: () => import('../pages/prepare-circular/List.vue')
    },
    {
        path: 'circular-request',
        name: prop + '.circular_request',
        meta: { auth: true },
        component: () => import('../pages/circular-request/List.vue')
    },
    {
        path: 'approved-circular',
        name: prop + '.approved_circular',
        meta: { auth: true },
        component: () => import('../pages/approved-circular/List.vue')
    },
    {
        path: 'published-circular',
        name: prop + '.published_circular',
        meta: { auth: true },
        component: () => import('../pages/published-circular/List.vue')
    },
    {
        path: 'online-admission',
        name: prop + '.online_admission',
        meta: { auth: true },
        component: () => import('../pages/online-admission/List.vue')
    },
    {
        path: 'online-admission-application-entry',
        name: prop + '.online_admission_application_entry',
        meta: { auth: true },
        component: () => import('../pages/online-admission/Form.vue')
    },
    {
        path: 'online-admission-application-details',
        name: prop + '.online_admission_application_details',
        meta: { auth: true },
        component: () => import('../pages/online-admission/Details.vue')
    },
    {
        path: 'admission-fee',
        name: prop + '.admission_fee',
        meta: { auth: true },
        component: () => import('../pages/admission-fee/List.vue')
    },
    {
        path: 'applicant-assessment',
        name: prop + '.applicant_assessment',
        meta: { auth: true },
        component: () => import('../pages/applicant-assessment/List.vue')
    },
    {
        path: 'applicant-approval',
        name: prop + '.applicant_approval',
        meta: { auth: true },
        component: () => import('../pages/applicant-approval/List.vue')
    },
    {
        path: 'refer-list',
        name: prop + '.refer_list',
        meta: { auth: true },
        component: () => import('../pages/refer-list/List.vue')
    }
]

const routes = [{
    path: '/disability-school-service/admission-management',
    name: 'disability_school_service.admission_management',
    component: () => import('@/layouts/DisabilitySchoolLayout.vue'),
    meta: { auth: true },
    children: admissionManagementRoutes('disability_school_service.admission_management')
}]
export default routes
